import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Portal } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { alertService } from 'src/services/alert.service';

export function AlertComponent() {
	const [open, setOpen] = useState(false);
	const [alertValues, setAlertValues] = useState(alertService.alert$);

	alertService.alert$.subscribe(v => {
		if ((v?.title || v?.message) && !open) handleOpen(v);
	});

	function handleOpen(v) {
		setOpen(true);
		setAlertValues(v)
	}

	function handleClose() {
		setOpen(false);
		alertService.dismiss();
	}

	return (
		<Portal>
			<Dialog open={open} disableBackdropClick disableEscapeKeyDown>
				<DialogTitle>{alertValues?.title}</DialogTitle>
				<DialogContent>
					<DialogContentText>{typeof alertValues?.message === 'string' ? alertValues?.message: 'Si è verificato un errore.' }</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						{alertValues?.buttonText || 'Ok'}
					</Button>
				</DialogActions>
			</Dialog>
		</Portal>
	);
}